export const getStakingMessages = () => {
    const STAKING_MENU = {
        DASHBOARD: [
            { message: 'Home', language: 'English' },
            { message: 'ホーム', language: 'Japanese' },
            { message: '首頁', language: 'Traditional' },
            { message: '首页', language: 'Simplified' },
        ],
        STAKING: [
            { message: 'Staking', language: 'English' },
            { message: '預入', language: 'Japanese' },
            { message: '質押入金', language: 'Traditional' },
            { message: '质押入金', language: 'Simplified' },
        ],
        CANCEL: [
            { message: 'Cancel', language: 'English' },
            { message: '解約', language: 'Japanese' },
            { message: '質押解約', language: 'Traditional' },
            { message: '质押解约', language: 'Simplified' },
        ],
        HISTORY: [
            { message: 'History', language: 'English' },
            { message: '履歴', language: 'Japanese' },
            { message: '紀錄', language: 'Traditional' },
            { message: '纪录', language: 'Simplified' },
        ],
        TERMS_OF_USE: [
            { message: 'Terms', language: 'English' },
            { message: '規約', language: 'Japanese' },
            { message: '相關條款', language: 'Traditional' },
            { message: '相关条款', language: 'Simplified' },
        ],
        TERMS_OF_USE_LINK: [
            { message: '/assets/docs/en/staking-rule-en.pdf', language: 'English' },
            { message: '/assets/docs/ja/staking-rule-ja.pdf', language: 'Japanese' },
            { message: '/assets/docs/en/staking-rule-en.pdf', language: 'Traditional' },
            { message: '/assets/docs/en/staking-rule-en.pdf', language: 'Simplified' },
        ],
    };
    const CHOICECARD = {
        WHAT: [
            { message: 'What currency do you want?', language: 'English' },
            { message: 'どの通貨にしますか?', language: 'Japanese' },
            { message: '您要使用哪種貨幣？', language: 'Traditional' },
            { message: '选择方案您要使用哪种货币？', language: 'Simplified' },
        ],
        CARD: [
            { message: 'Max', language: 'English' },
            { message: '最大', language: 'Japanese' },
            { message: '上限', language: 'Traditional' },
            { message: '上限', language: 'Simplified' },
        ],
        EMPTY: [
            { message: 'Sorry, there are currently no plans to choose from.', language: 'English' },
            { message: '申し訳ございません、現在お選びいただけるプランがございません。', language: 'Japanese' },
            { message: '抱歉，目前無方案可供選擇。', language: 'Traditional' },
            { message: '抱歉，目前无方案可供选择。', language: 'Simplified' },
        ],
    };
    const PLANCARD = {
        WHAT: [
            { message: 'Which plan would you like?', language: 'English' },
            { message: 'どのプランにしますか？', language: 'Japanese' },
            { message: '您要選擇哪種方案？', language: 'Traditional' },
            { message: '您要选择哪种方案？', language: 'Simplified' },
        ],
        RATE: [
            { message: 'Interest Rate', language: 'English' },
            { message: '利率（年利)', language: 'Japanese' },
            { message: '利率（年利率)', language: 'Traditional' },
            { message: '利率（年利率)', language: 'Simplified' },
        ],
        PERIOD: [
            { message: 'Term', language: 'English' },
            { message: '期間', language: 'Japanese' },
            { message: '期間', language: 'Traditional' },
            { message: '期间', language: 'Simplified' },
        ],
        DAY: [
            { message: 'Day', language: 'English' },
            { message: '日', language: 'Japanese' },
            { message: '天', language: 'Traditional' },
            { message: '天', language: 'Simplified' },
        ],
        PLAN: [
            { message: 'Flexible Plan', language: 'English' },
            { message: 'フレキシブルプラン', language: 'Japanese' },
            { message: 'Flexible', language: 'Traditional' },
            { message: 'Flexible', language: 'Simplified' },
        ],
        ON_STAKE: [
            { message: 'On Stake', language: 'English' },
            { message: 'ステーク中', language: 'Japanese' },
            { message: '已質押', language: 'Traditional' },
            { message: '已质押', language: 'Simplified' },
        ],
    };
    const STAKING = {
        ENTER: [
            { message: 'Please enter the quantity to deposit', language: 'English' },
            { message: '預け入れる数量を入力してください', language: 'Japanese' },
            { message: '請輸入欲質押入金的貨幣數量', language: 'Traditional' },
            { message: '请输入欲质押入金的货币数量', language: 'Simplified' },
        ],
        QUANTITY: [
            { message: 'Minimum quantity', language: 'English' },
            { message: '最小数量', language: 'Japanese' },
            { message: '最小数量', language: 'Traditional' },
            { message: '最小数量', language: 'Simplified' },
        ],
        AMOUNT: [
            { message: 'Maximum deposit', language: 'English' },
            { message: '預入限度額', language: 'Japanese' },
            { message: '可入金上限額度', language: 'Traditional' },
            { message: '可入金上限额度', language: 'Simplified' },
        ],
        BTN: [
            { message: 'Confirm', language: 'English' },
            { message: '確認する', language: 'Japanese' },
            { message: '確認', language: 'Traditional' },
            { message: '确认', language: 'Simplified' },
        ],
        ANNUAL_INTEREST: [
            { message: 'Interest rate (annual)', language: 'English' },
            { message: '利率（年利）', language: 'Japanese' },
            { message: '利率（年利率)', language: 'Traditional' },
            { message: '利率（年利率)', language: 'Simplified' },
        ],
        MAX_STAKE: [
            { message: 'Stake is greater than max stake', language: 'English' },
            { message: '預入限度額より小さい数を入力してください。', language: 'Japanese' },
            { message: '請輸入最大限額以下的數量。', language: 'Traditional' },
            { message: '请输入最大限额以下的数量。', language: 'Simplified' },
        ],
        MIN_STAKE: [
            { message: 'Stake is less than minimum stake', language: 'English' },
            { message: '最小数量より大きい数を入力してください。', language: 'Japanese' },
            { message: '請輸入最小額度以上的數量。', language: 'Traditional' },
            { message: '请输入最小额度以上的数量。', language: 'Simplified' },
        ],
        INPUT_STAKE: [
            { message: 'Please input amount!', language: 'English' },
            { message: '数量を入力してください。', language: 'Japanese' },
            { message: '請輸入欲質押入金的貨幣數量', language: 'Traditional' },
            { message: '请输入欲质押入金的货币数量', language: 'Simplified' },
        ],
        PERIOD: [
            { message: 'Term', language: 'English' },
            { message: '期間', language: 'Japanese' },
            { message: '期間', language: 'Traditional' },
            { message: '期间', language: 'Simplified' },
        ],
        DISABLED_MSG: [
            { message: 'CRYPTOS balance is insufficient.', language: 'English' },
            { message: 'CRYPTOS残高不足の為、ご利用いただけません。', language: 'Japanese' },
            { message: '由於CRYPTOS餘額不足，無法使用。', language: 'Traditional' },
            { message: '由于CRYPTOS余额不足，无法使用。', language: 'Simplified' },
        ],
    };
    const STAKECONFIRM = {
        APPDATE: [
            { message: 'App. date', language: 'English' },
            { message: '申込日', language: 'Japanese' },
            { message: '申請日期', language: 'Traditional' },
            { message: '申请日期', language: 'Simplified' },
        ],
        STARTDATE: [
            { message: 'Start date', language: 'English' },
            { message: '開始日', language: 'Japanese' },
            { message: '開始日期', language: 'Traditional' },
            { message: '开始日期', language: 'Simplified' },
        ],
        ENDDATE: [
            { message: 'End date', language: 'English' },
            { message: '終了日', language: 'Japanese' },
            { message: '結束日期', language: 'Traditional' },
            { message: '结束日期', language: 'Simplified' },
        ],
        REDEMDATE: [
            { message: 'Redeem date', language: 'English' },
            { message: '償還日', language: 'Japanese' },
            { message: '贖回日期', language: 'Traditional' },
            { message: '赎回日期', language: 'Simplified' },
        ],
        PLAN: [
            { message: 'Plan', language: 'English' },
            { message: 'プラン', language: 'Japanese' },
            { message: '方案', language: 'Traditional' },
            { message: '方案', language: 'Simplified' },
        ],
        RATE: [
            { message: 'Interest rate', language: 'English' },
            { message: '利率', language: 'Japanese' },
            { message: '利率', language: 'Traditional' },
            { message: '利率', language: 'Simplified' },
        ],
        QUANTITY: [
            { message: 'Quantity', language: 'English' },
            { message: '数量', language: 'Japanese' },
            { message: '數量', language: 'Traditional' },
            { message: '数量', language: 'Simplified' },
        ],
        INTEREST: [
            { message: 'Interest', language: 'English' },
            { message: '利息', language: 'Japanese' },
            { message: '利息', language: 'Traditional' },
            { message: '利息', language: 'Simplified' },
        ],
        TERM: [
            {
                message: 'I have read and agree to the <a href="/assets/docs/en/staking-rule-en.pdf" target="_blank" style="color: #669cfc;">CRYPTOS STAKING Terms of Service.</a>',
                language: 'English',
            },
            {
                message: '私は<a href="/assets/docs/ja/staking-rule-ja.pdf" target="_blank" style="color: #669cfc;">CRYPTOS STAKINGサービス規約</a>を読み、同意します。',
                language: 'Japanese',
            },
            {
                message: '我已詳閱 <a href="/assets/docs/en/staking-rule-en.pdf" target="_blank" style="color: #669cfc;">CRYPTOS STAKING 服務規章且同意。</a>',
                language: 'Traditional',
            },
            {
                message: '我已详阅 <a href="/assets/docs/en/staking-rule-en.pdf" target="_blank" style="color: #669cfc;">CRYPTOS STAKING 服务规章且同意。</a>',
                language: 'Simplified',
            },
        ],
        DAY: [
            { message: 'Day', language: 'English' },
            { message: '日', language: 'Japanese' },
            { message: '天', language: 'Traditional' },
            { message: '天', language: 'Simplified' },
        ],
        BTN: [
            { message: 'Stake', language: 'English' },
            { message: 'ステーキングする', language: 'Japanese' },
            { message: '進行質押', language: 'Traditional' },
            { message: '进行质押', language: 'Simplified' },
        ],
    };
    const STAKECOMPLETE = {
        DONE: [
            { message: 'Staking completed.', language: 'English' },
            { message: 'ステーキングが完了しました。', language: 'Japanese' },
            { message: '已成功進行質押。', language: 'Traditional' },
            { message: '已成功进行质押。', language: 'Simplified' },
        ],
        BTN: [
            { message: 'See dashboard', language: 'English' },
            { message: 'ダッシュボードを見る', language: 'Japanese' },
            { message: '回到質押首頁', language: 'Traditional' },
            { message: '回到质押首页', language: 'Simplified' },
        ],
    };
    const GOBACK = {
        NOW: [
            { message: 'Return', language: 'English' },
            { message: '戻る', language: 'Japanese' },
            { message: '返回', language: 'Traditional' },
            { message: '返回', language: 'Simplified' },
        ],
    };
    const STEPPERS = {
        STEP1: [
            { message: 'Currency Selection', language: 'English' },
            { message: '通貨選択', language: 'Japanese' },
            { message: '選擇交易貨幣', language: 'Traditional' },
            { message: '选择交易货币', language: 'Simplified' },
        ],
        STEP2: [
            { message: 'Plan Selection', language: 'English' },
            { message: 'プラン選択', language: 'Japanese' },
            { message: '選擇方案', language: 'Traditional' },
            { message: '选择方案', language: 'Simplified' },
        ],
        STEP3: [
            { message: 'Quantity Input', language: 'English' },
            { message: '数量入力', language: 'Japanese' },
            { message: '輸入數量', language: 'Traditional' },
            { message: '输入数量', language: 'Simplified' },
        ],
        STEP4: [
            { message: 'Confirmation', language: 'English' },
            { message: '確認', language: 'Japanese' },
            { message: '確認', language: 'Traditional' },
            { message: '确认', language: 'Simplified' },
        ],
        STEP5: [
            { message: 'Completion', language: 'English' },
            { message: '完了', language: 'Japanese' },
            { message: '完成', language: 'Traditional' },
            { message: '完成', language: 'Simplified' },
        ],
        CURRENCY_SELECT: [
            { message: 'Currency Selection', language: 'English' },
            { message: '通貨選択', language: 'Japanese' },
            { message: '選擇交易貨幣', language: 'Traditional' },
            { message: '选择交易货币', language: 'Simplified' },
        ],
        PLAN_SELECT: [
            { message: 'Plan Selection', language: 'English' },
            { message: 'プラン選択', language: 'Japanese' },
            { message: '選擇方案', language: 'Traditional' },
            { message: '选择方案', language: 'Simplified' },
        ],
        AMOUNT_INPUT: [
            { message: 'Quantity Input', language: 'English' },
            { message: '数量入力', language: 'Japanese' },
            { message: '輸入數量', language: 'Traditional' },
            { message: '输入数量', language: 'Simplified' },
        ],
        CONFIRM: [
            { message: 'Confirmation', language: 'English' },
            { message: '確認', language: 'Japanese' },
            { message: '確認', language: 'Traditional' },
            { message: '确认', language: 'Simplified' },
        ],
        COMPLETE: [
            { message: 'Complete', language: 'English' },
            { message: '完了', language: 'Japanese' },
            { message: '完成', language: 'Traditional' },
            { message: '完成', language: 'Simplified' },
        ],
    };
    const STAKING_HISTORY = {
        PAGE: [
            { message: 'Staking History', language: 'English' },
            { message: 'ステーキング履歴', language: 'Japanese' },
            { message: '質押紀錄', language: 'Traditional' },
            { message: '质押纪录', language: 'Simplified' },
        ],
        SHOW: [
            { message: 'Show All', language: 'English' },
            { message: '全て表示する', language: 'Japanese' },
            { message: '顯示全部', language: 'Traditional' },
            { message: '显示全部', language: 'Simplified' },
        ],
        HEADER_SYMBOL: [
            { message: 'Currency', language: 'English' },
            { message: '通貨', language: 'Japanese' },
            { message: '貨幣', language: 'Traditional' },
            { message: '货币', language: 'Simplified' },
        ],
        HEADER_PERIOD: [
            { message: 'Period', language: 'English' },
            { message: '期間', language: 'Japanese' },
            { message: '期間', language: 'Traditional' },
            { message: '期间', language: 'Simplified' },
        ],
        HEADER_AMOUNT: [
            { message: 'Quantity', language: 'English' },
            { message: '数量', language: 'Japanese' },
            { message: '數量', language: 'Traditional' },
            { message: '数量', language: 'Simplified' },
        ],
        HEADER_EXPECTED: [
            { message: 'Expected interest', language: 'English' },
            { message: '予定利息', language: 'Japanese' },
            { message: '預計獲得利息', language: 'Traditional' },
            { message: '预计获得利息', language: 'Simplified' },
        ],
        HEADER_RESULT_AMOUNT: [
            { message: 'Result amount', language: 'English' },
            { message: '利息(償還後)', language: 'Japanese' },
            { message: '利息(贖回後)', language: 'Traditional' },
            { message: '利息(赎回后)', language: 'Simplified' },
        ],
        HEADER_START: [
            { message: 'Start date', language: 'English' },
            { message: '開始日', language: 'Japanese' },
            { message: '開始日期', language: 'Traditional' },
            { message: '开始日期', language: 'Simplified' },
        ],
        HEADER_END: [
            { message: 'End date', language: 'English' },
            { message: '終了日', language: 'Japanese' },
            { message: '結束日期', language: 'Traditional' },
            { message: '结束日期', language: 'Simplified' },
        ],
        HEADER_REMAINING: [
            { message: 'Remaining days', language: 'English' },
            { message: '残日数', language: 'Japanese' },
            { message: '剩餘日數', language: 'Traditional' },
            { message: '剩余日数', language: 'Simplified' },
        ],
        HEADER_STATUS: [
            { message: 'Status', language: 'English' },
            { message: '状態', language: 'Japanese' },
            { message: '狀態', language: 'Traditional' },
            { message: '状态', language: 'Simplified' },
        ],
        TABLE_EMPTY: [
            { message: 'No stake data found.', language: 'English' },
            { message: 'ステークデータが見つかりません。', language: 'Japanese' },
            { message: '無質押中資料。', language: 'Traditional' },
            { message: '无质押中资料。', language: 'Simplified' },
        ],
        TABLE_LOADING: [
            { message: 'Loading stake data. Please wait.', language: 'English' },
            { message: 'ステークデータを読み込んでいます。お待ちください。', language: 'Japanese' },
            { message: '正在讀取質押資料，請稍候。', language: 'Traditional' },
            { message: '正在读取质押资料，请稍候。', language: 'Simplified' },
        ],
        DAY: [
            { message: 'Days', language: 'English' },
            { message: '日', language: 'Japanese' },
            { message: '天', language: 'Traditional' },
            { message: '天', language: 'Simplified' },
        ],
        STATUS_APPLYING: [
            { message: 'Applying', language: 'English' },
            { message: '申込中', language: 'Japanese' },
            { message: '申請中', language: 'Traditional' },
            { message: '申请中', language: 'Simplified' },
        ],
        STATUS_STAKING: [
            { message: 'Staking', language: 'English' },
            { message: 'ステーク中', language: 'Japanese' },
            { message: '質押中', language: 'Traditional' },
            { message: '质押中', language: 'Simplified' },
        ],
        STATUS_CANCEL: [
            { message: 'Cancelled', language: 'English' },
            { message: '途中解約', language: 'Japanese' },
            { message: '中途解約', language: 'Traditional' },
            { message: '中途取消', language: 'Simplified' },
        ],
        STATUS_MATURITY: [
            { message: 'Maturity', language: 'English' },
            { message: '満期', language: 'Japanese' },
            { message: '到期日', language: 'Traditional' },
            { message: '到期日', language: 'Simplified' },
        ],
        STATUS_COMPLETE: [
            { message: 'Complete', language: 'English' },
            { message: '完了', language: 'Japanese' },
            { message: '結束', language: 'Traditional' },
            { message: '结束', language: 'Simplified' },
        ],
        FREE: [
            { message: 'Flexible', language: 'English' },
            { message: 'Flexible', language: 'Japanese' },
            { message: 'Flexible', language: 'Traditional' },
            { message: 'Flexible', language: 'Simplified' },
        ],
    };
    const DASHBOARD_PAGE = {
        GRAPH_TITLE: [
            { message: 'Staking and Cryptos Assets Ratio', language: 'English' },
            { message: 'ステーキングと暗号資産比率', language: 'Japanese' },
            { message: '質押與虛擬資產比率', language: 'Traditional' },
            { message: '质押与虚拟资产比率', language: 'Simplified' },
        ],
        STAKING: [
            { message: 'Staking', language: 'English' },
            { message: 'ステーキング中', language: 'Japanese' },
            { message: '質押中', language: 'Traditional' },
            { message: '质押中', language: 'Simplified' },
        ],
        BALANCE: [
            { message: 'CRYPTOS Balance', language: 'English' },
            { message: 'CRYPTOS残高', language: 'Japanese' },
            { message: 'CRYPTOS餘額', language: 'Traditional' },
            { message: 'CRYPTOS余额', language: 'Simplified' },
        ],
        EMPTY: [
            { message: 'Currently No Data Found!', language: 'English' },
            { message: 'データが見つかりませんでした！', language: 'Japanese' },
            { message: '目前無資料！', language: 'Traditional' },
            { message: '目前无数据！', language: 'Simplified' },
        ],
    };
    const STAKING_LIST_TITLES = {
        STAKING_LIST: [
            { message: 'Staking Cancellation', language: 'English' },
            { message: 'ステーキングを解約する', language: 'Japanese' },
            { message: '質押方案解約', language: 'Traditional' },
            { message: '质押方案解约', language: 'Simplified' },
        ],
        SUBMIT: [
            { message: 'Cancel', language: 'English' },
            { message: '解約する', language: 'Japanese' },
            { message: '確認解約', language: 'Traditional' },
            { message: '确认解约', language: 'Simplified' },
        ],
        CANCEL: [
            { message: 'Do not Cancel', language: 'English' },
            { message: '解約しない', language: 'Japanese' },
            { message: '取消解約', language: 'Traditional' },
            { message: '取消解约', language: 'Simplified' },
        ],
        CANCEL_SUCCESS: [
            { message: 'Canceled Successfully', language: 'English' },
            { message: '正常にキャンセルされました', language: 'Japanese' },
            { message: '解約完成', language: 'Traditional' },
            { message: '取消完成', language: 'Simplified' },
        ],
        CANCEL_ERROR: [
            { message: 'Canceled Unsuccessfully', language: 'English' },
            { message: 'キャンセルに失敗しました', language: 'Japanese' },
            { message: '解約失敗', language: 'Traditional' },
            { message: '取消失败', language: 'Simplified' },
        ],
        RETURN: [
            { message: 'Return', language: 'English' },
            { message: '戻る', language: 'Japanese' },
            { message: '返回', language: 'Traditional' },
            { message: '返回', language: 'Simplified' },
        ],
        ALERT: [
            { message: 'Are you sure you want to cancel?', language: 'English' },
            { message: '解約しますか？', language: 'Japanese' },
            { message: '確定要解約嗎？', language: 'Traditional' },
            { message: '确定要解约吗？', language: 'Simplified' },
        ],
        CHECKBOX: [
            { message: 'I understand that I cannot receive interest.', language: 'English' },
            { message: '利息を受け取ることができないことを了承する。', language: 'Japanese' },
            { message: '我理解中途解約後無法獲得利息', language: 'Traditional' },
            { message: '我理解中途解约后无法获得利息', language: 'Simplified' },
        ],
    };
    const STAKING_LIST_HEADER = {
        CURRENCY: [
            { message: 'Currency', language: 'English' },
            { message: '通貨', language: 'Japanese' },
            { message: '貨幣', language: 'Traditional' },
            { message: '货币', language: 'Simplified' },
        ],
        PLAN: [
            { message: 'Plan', language: 'English' },
            { message: 'プラン', language: 'Japanese' },
            { message: '方案', language: 'Traditional' },
            { message: '方案', language: 'Simplified' },
        ],
        QUANTITY: [
            { message: 'Amount', language: 'English' },
            { message: '数量', language: 'Japanese' },
            { message: '數量', language: 'Traditional' },
            { message: '数量', language: 'Simplified' },
        ],
        PLAN_INTEREST: [
            { message: 'Plan Interest', language: 'English' },
            { message: '予定利息', language: 'Japanese' },
            { message: '預計獲得利息', language: 'Traditional' },
            { message: '预计获得利息', language: 'Simplified' },
        ],
        REMAINING_DAYS: [
            { message: 'Remaining Days', language: 'English' },
            { message: '残日数', language: 'Japanese' },
            { message: '剩餘日數', language: 'Traditional' },
            { message: '剩余日数', language: 'Simplified' },
        ],
    };
    const STAKING_LIST_CONTENT = {
        TERM: [
            { message: '-day', language: 'English' },
            { message: '日プラン', language: 'Japanese' },
            { message: '天方案', language: 'Traditional' },
            { message: '天方案', language: 'Simplified' },
        ],
        REMAINING_DAYS: [
            { message: ' days', language: 'English' },
            { message: '日', language: 'Japanese' },
            { message: '天', language: 'Traditional' },
            { message: '天', language: 'Simplified' },
        ],
        REMAINING_DAYS_1: [
            { message: '', language: 'English' },
            { message: 'あと', language: 'Japanese' },
            { message: '還剩', language: 'Traditional' },
            { message: '还剩', language: 'Simplified' },
        ],
        REMAINING_DAYS_2: [
            { message: ' days left', language: 'English' },
            { message: '日', language: 'Japanese' },
            { message: '天', language: 'Traditional' },
            { message: '天', language: 'Simplified' },
        ],
        PERCENT: [
            { message: '%', language: 'English' },
            { message: '％', language: 'Japanese' },
            { message: '%', language: 'Traditional' },
            { message: '%', language: 'Simplified' },
        ],
        FREE: [
            { message: 'Flexible ', language: 'English' },
            { message: 'フレキシブル', language: 'Japanese' },
            { message: 'Flexible', language: 'Traditional' },
            { message: 'Flexible', language: 'Simplified' },
        ],
        PLAN: [
            { message: 'Plan', language: 'English' },
            { message: 'プラン', language: 'Japanese' },
            { message: '', language: 'Traditional' },
            { message: '', language: 'Simplified' },
        ],
    };
    const STAKING_FUND_LABELS = {
        PLAN: [
            { message: 'Plan', language: 'English' },
            { message: 'プラン', language: 'Japanese' },
            { message: '方案', language: 'Traditional' },
            { message: '方案', language: 'Simplified' },
        ],
        RATE: [
            { message: 'Interest Rate', language: 'English' },
            { message: '利率', language: 'Japanese' },
            { message: '利率', language: 'Traditional' },
            { message: '利率', language: 'Simplified' },
        ],
        AMOUNT: [
            { message: 'Amount', language: 'English' },
            { message: '数量', language: 'Japanese' },
            { message: '數量', language: 'Traditional' },
            { message: '数量', language: 'Simplified' },
        ],
        INTEREST: [
            { message: 'Estimated Interest', language: 'English' },
            { message: '予定利息', language: 'Japanese' },
            { message: '預計獲得利息', language: 'Traditional' },
            { message: '预计获得利息', language: 'Simplified' },
        ],
        DATE: [
            { message: 'Maturity Date', language: 'English' },
            { message: '満期', language: 'Japanese' },
            { message: '到期日', language: 'Traditional' },
            { message: '到期日', language: 'Simplified' },
        ],
    };
    return {
        STAKING_MENU,
        DASHBOARD_PAGE,
        GOBACK,
        STEPPERS,
        CHOICECARD,
        PLANCARD,
        STAKING,
        STAKECONFIRM,
        STAKECOMPLETE,
        STAKING_HISTORY,
        STAKING_LIST_TITLES,
        STAKING_LIST_HEADER,
        STAKING_LIST_CONTENT,
        STAKING_FUND_LABELS,
    };
};
